import React from 'react';
import { RetweetOutlined } from '@ant-design/icons';

import BorderlessButton from '../../common/buttons/BorderlessButton';
import OntraccrPopconfirm from '../../common/modals/OntraccrPopconfirm';

export default ({
  title,
  name,
  onUnLink
}) => (
  <OntraccrPopconfirm
    placement='right'
    title={
      <div style={{ width: 300}}>
        <b>{`Unlink ${name}?`}</b>
        <br/><br/>
        Entries that are unlinked can no longer be synced between Ontraccr and {title}.
      </div>
    }
    onConfirm={onUnLink}
    okText='Unlink'
    cancelText='Cancel'
  >
    <BorderlessButton
      iconNode={<RetweetOutlined style={{ margin: 0}}/>}
      style={{ padding: 0 }}
    /> 
  </OntraccrPopconfirm>
);